var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 37,
    viewBox: "0 0 39 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1937 1.68286H30.4803V4.112H33.1937C33.9908 4.112 34.6392 4.7272 34.6392 5.48338V8.05763H37.1996V5.48338C37.1996 3.38775 35.4026 1.68286 33.1937 1.68286ZM4.34169 5.48338C4.34169 4.7272 4.99014 4.112 5.78721 4.112H8.50068V1.68286H5.78721C3.5783 1.68286 1.78125 3.38775 1.78125 5.48338V8.05763H4.34169V5.48338ZM34.6392 31.4844C34.6392 32.2406 33.9908 32.8558 33.1937 32.8558H30.4803V35.2849H33.1937C35.4026 35.2849 37.1996 33.58 37.1996 31.4844V28.9101H34.6392V31.4844ZM4.34169 31.4844V28.9101H1.78125V31.4844C1.78125 33.58 3.5783 35.2849 5.78721 35.2849H8.50068V32.8558H5.78721C4.99014 32.8558 4.34169 32.2406 4.34169 31.4844Z",
    fill: "#474747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9195 17.2693H3.06152V19.6984H35.9195V17.2693Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.25ec796ea270f00c676b7d7a7d8fd2cc.svg";
export { ForwardRef as ReactComponent };